<template>
  <div
    class="divide-x divide-slate-200 overflow-hidden rounded-md border border-slate-300"
  >
    <button
      v-if="originalRequest.length > max_button_page"
      class="px-3 py-2 disabled:cursor-not-allowed disabled:bg-gray-100"
      :disabled="!previousPageAvailable"
      @click="previousPage"
    >
      <FontAwesomeIcon :icon="['fal', 'chevron-left']" />
    </button>
    <ItemsPaginationButton
      v-for="(id, idx) in originalRequestStockableIds"
      :key="id"
      :value="idx + 1"
      :original-item="originalRequest[id]"
      :selected="page === id"
      @click="setCurrentPage(id)"
    />
    <button
      v-if="originalRequest.length > max_button_page"
      class="px-3 py-2 disabled:cursor-not-allowed disabled:bg-gray-100"
      :disabled="!nextPageAvailable"
      @click="nextPage"
    >
      <FontAwesomeIcon :icon="['fal', 'chevron-right']" />
    </button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ItemsPaginationButton from '@c/Stock/Component/ItemsPaginationButton.vue'

export default {
  name: 'ItemsPagination',
  components: { ItemsPaginationButton, FontAwesomeIcon },
  props: {
    page: {
      type: String,
      required: true
    },
    originalRequest: {
      type: Array,
      required: true
    }
  },
  emits: ['update:page'],
  data() {
    return {
      max_button_page: 5
    }
  },
  computed: {
    localPage: {
      get() {
        return this.page
      },
      set(value) {
        this.$emit('update:page', value)
      }
    },
    originalRequestStockableIds() {
      return this.originalRequest
        // .map((request, idx) => ( idx))
        .map((request, idx) => (request.item ? idx : null))
        .filter((idx) => idx !== null)
    },
    nextPageAvailable() {
      return this.localPage < this.originalRequest.length - 1
    },
    previousPageAvailable() {
      return this.localPage > 0
    }
  },
  methods: {
    nextPage() {
      if (this.localPage >= this.originalRequest.length) {
        return
      }
      this.localPage = this.localPage + 1
    },
    previousPage() {
      if (this.localPage === 0) {
        return
      }
      this.localPage = this.localPage - 1
    },
    setCurrentPage(id) {
      this.localPage = id
    }
  }
}
</script>
